var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "m1 1 16 16m0-16L1 17"
})));
export default SvgCross;